export const NS = ".kendoSmartPasteButton";

export const EVENTS = {
    requestStart: "requestStart",
    requestEnd: "requestEnd",
    error: "error",
    click: "click"
};

export const STYLES = {
    smartPasteButton: "k-smart-paste-button"
};